import { filing } from './toolkit';

/** Schedule D(a): Distributee who post-deceased the decedent (administration proceeding). */
export default filing('file-1787253620509-89f4ded1-a993-415d-ae30-807eb9ce18ff.pdf', 'Schedule D(a): distributee who post-deceased the decedent', f => {
  f.shared('Text Field167', 'estate.courtFileNumber', 'File number');
  f.dropdown('Combo Box0', 'proceedingType', 'Proceeding for', 'Proceeding',
    ['LETTERS OF ADMINISTRATION', 'LETTERS OF ADMINISTRATION D.B.N.', 'VOLUNTARY ADMINISTRATION']);
  f.shared('Text Field164', 'decedent.fullName', 'Estate of (decedent name)');
  f.notApplicable('Text Field165', 'Estate of: second name line', 'Continuation line for a long decedent name. The full name prints on the first line.');
  f.shared('Text Field166', 'decedent.otherNames', 'a/k/a (other names of the decedent)');

  f.person('postDeceased', 'Distributee who died after the decedent', '1. Post-deceased distributee',
    'Select the participant. Their name, date of death, relationship to the decedent and last address come from their participant record.');
  f.personField('Text Field168', 'postDeceased', 'fullName', '1. Name');
  f.personField('Text Field169', 'postDeceased', 'dateOfDeath', '1. Date of death');
  f.personField('Text Field170', 'postDeceased', 'relationshipToDecedent', '1. Relationship to decedent');
  f.personField('Text Field171', 'postDeceased', 'fullAddress', '1. Last permanent address (domicile)');

  f.choice('fiduciaryAppointed', "2. Is there a court-appointed fiduciary for this person's estate?", '2. Fiduciary', [
    { label: 'Yes (complete 3(a))', value: 'Yes', fields: ['Check Box0'] },
    { label: 'No (complete 3(b))', value: 'No', fields: ['Check Box01'] },
  ], 'checkbox');

  f.people('fiduciaries', '3(a). Court-appointed fiduciaries of the post-deceased person', '3(a). Fiduciary', 2, 'Appointing court',
    'Select the fiduciary. Name, address and citizenship come from Participants; enter the court that appointed them.');
  f.peopleField('Text Field174', 'fiduciaries', 0, 'line', '3(a). Fiduciary 1: name; address; citizenship; court');
  f.peopleField('Text Field176', 'fiduciaries', 1, 'line', '3(a). Fiduciary 2: name; address; citizenship; court');

  f.people('heirs', "3(b). The post-deceased person's distributees (heirs)", '3(b). Distributees', 6, "Relationship to the post-deceased person");
  ['Text Field175', 'Text Field177', 'Text Field178', 'Text Field179', 'Text Field180', 'Text Field181'].forEach((field, i) =>
    f.peopleField(field, 'heirs', i, 'line', `3(b). Distributee ${i + 1}: name; address; citizenship; relationship`));
});
